import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a9bc2b2a&functional=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andy1229/專案/vue_後端網頁介面參考/魚類販賣系統/shopstore_fish/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9bc2b2a')) {
      api.createRecord('a9bc2b2a', component.options)
    } else {
      api.rerender('a9bc2b2a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a9bc2b2a&functional=true&", function () {
      api.rerender('a9bc2b2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/nested/menu1/menu1-2/menu1-2-1/index.vue"
export default component.exports